<template>
  <nav id="nav" class="navbar navbar-expand-lg navbar-dark shadow fixed-top">
    <div class="container">
      <a href="/" style="padding: 0px">
        <img
          src="../assets/images/logo.jpg"
          style="height: 75px"
          alt="Waiheke Adventure Centre"
        />
      </a>
      <button
        class="navbar-toggler border-0"
        type="button"
        data-toggle="collapse"
        data-target="#navbarResponsive"
        aria-controls="navbarResponsive"
        aria-expanded="false"
        aria-label="Toggle navigation"
        style="font-size: 16px"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarResponsive">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <router-link
              class="nav-link"
              data-toggle="collapse"
              data-target=".navbar-collapse.show"
              to="/"
            >
              Home
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link"
              data-toggle="collapse"
              data-target=".navbar-collapse.show"
              to="/water-activities"
            >
              Water Activities
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link"
              data-toggle="collapse"
              data-target=".navbar-collapse.show"
              to="/land-activities"
            >
              Land Activities
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link"
              data-toggle="collapse"
              data-target=".navbar-collapse.show"
              to="/team-building"
            >
              Team Building
            </router-link>
          </li>
          <!-- Visible only on small -->
          <li class="nav-item d-block d-md-none">
            <router-link
              class="nav-link"
              data-toggle="collapse"
              data-target=".navbar-collapse.show"
              to="/gallery"
            >
              Gallery
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link"
              data-toggle="collapse"
              data-target=".navbar-collapse.show"
              to="/about-us"
            >
              About Us
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link"
              data-toggle="collapse"
              data-target=".navbar-collapse.show"
              to="/contact"
            >
              Contact
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<style lang="scss">
@media (min-width: 768px) {
  .navbar {
    padding: 0px !important;
  }
}

.navbar {
  background-color: #292929 !important;

  .nav-item {
    padding-left: 20px;
  }

  a {
    &.router-link-exact-active {
      color: #f06a29 !important;
    }
  }

  button:focus {
    outline: none !important;
  }
}
</style>

<script>
export default {
  name: "Header",
};
</script>
